var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.634,
    height: 31.634,
    viewBox: "0 0 31.634 31.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "collage",
    transform: "translate(-19.125 -19.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M32.41,27.85a2.28,2.28,0,0,1-2.28,2.28H22.28A2.28,2.28,0,0,1,20,27.85V22.28A2.28,2.28,0,0,1,22.28,20h7.849a2.28,2.28,0,0,1,2.281,2.28Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M304.663,34.941a2.28,2.28,0,0,1-2.28,2.28h-8.1a2.28,2.28,0,0,1-2.28-2.28V22.28A2.28,2.28,0,0,1,294.28,20h8.1a2.28,2.28,0,0,1,2.281,2.28Z",
    transform: "translate(-254.779)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M304.663,377.317a2.28,2.28,0,0,1-2.28,2.28h-8.1a2.28,2.28,0,0,1-2.28-2.28v-3.037A2.281,2.281,0,0,1,294.28,372h8.1a2.281,2.281,0,0,1,2.281,2.28Z",
    transform: "translate(-254.779 -329.713)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M32.41,268.662a2.28,2.28,0,0,1-2.28,2.28H22.28a2.28,2.28,0,0,1-2.28-2.28V258.28A2.28,2.28,0,0,1,22.28,256h7.849a2.28,2.28,0,0,1,2.281,2.28Z",
    transform: "translate(0 -221.058)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.b5d9bdfe93bb484c2fd42bdc5b13fb8a.svg";
export { ForwardRef as ReactComponent };